import { TravelRequestsClient } from "../api/swagger/ApiClient";
import { ServiceBase } from "../support/base_classes/service-base";
import { autoinject } from 'aurelia-framework';

@autoinject
export class TravelRequestsService extends ServiceBase {
  maxFileSizeInBytes = 0;
  allowedFileExtensions = [];
  maxAllowedAttachmensCount = 5;

  constructor(private client: TravelRequestsClient) {
    super();
  }

  protected async initializeService() {
    await this.reload();
  }

  private async reload() {
    const attachmentSettings = await this.client.getAttachmentSettings();
    this.allowedFileExtensions = attachmentSettings.allowedFileExtensions;
    this.maxFileSizeInBytes = attachmentSettings.maxFileSizeInBytes;
  }
}
